export const FEED_BACK_REQUEST = "FEED_BACK_REQUEST";
export const FEED_BACK_SUCCESS = "FEED_BACK_SUCCESS";
export const FEED_BACK_FAIL = "FEED_BACK_FAIL";
